import * as Yup from 'yup'

export const samDataSchema = Yup.object().shape({
  email_subject: Yup.string()
    .min(10, 'Email subject should contain at least 10 characters')
    .max(140, 'Email subject should not exceed 140 characters')
    .required('Required'),
  email_body: Yup.string()
    .min(20, 'Email body should contain at least 20 characters')
    .max(1000, 'Email body should not exceed 1000 characters')
    .required('Required'),
  email_remainder_interval: Yup.number()
    .typeError('Only numbers are allowed')
    .min(0, 'Only positive integers are allowed')
    .integer('Decimal numbers are not allowed')
    .max(99, 'Maximum interval is 99 days')
    .required('Required'),
  email_remainder_emails_number: Yup.number()
    .typeError('Only numbers are allowed')
    .min(0, 'Only positive integers are allowed')
    .integer('Decimal numbers are not allowed')
    .max(9, 'No more than 9 reminders are allowed')
    .required('Required'),
  email_remainder_email_subject: Yup.string()
    .min(10, 'Email subject should contain at least 10 characters')
    .max(140, 'Email subject should not exceed 140 characters')
    .required('Required'),
  email_remainder_email_body: Yup.string()
    .min(20, 'Email body should contain at least 20 characters')
    .max(1000, 'Email body should not exceed 1000 characters')
    .required('Required'),
  consent_copy_header: Yup.string()
    .min(2, 'Header should contain at least 2 characters')
    .max(50, 'Header should not exceed 50 characters')
    .required('Required'),
  consent_copy_body_block_1: Yup.string()
    .min(10, 'Block should contain at least 10 characters')
    .max(255, 'Block should not exceed 255 characters')
    .required('Required'),
  consent_copy_body_block_2: Yup.string()
    .min(10, 'Block should contain at least 10 characters')
    .max(255, 'Block should not exceed 255 characters')
    .required('Required'),
  consent_copy_body_block_3: Yup.string()
    .min(10, 'Block should contain at least 10 characters')
    .max(255, 'Block should not exceed 255 characters')
    .required('Required'),
  consent_copy_body_block_4: Yup.string()
    .min(10, 'Block should contain at least 10 characters')
    .max(255, 'Block should not exceed 255 characters')
    .required('Required'),
  consent_copy_body_block_5: Yup.string()
    .min(10, 'Block should contain at least 10 characters')
    .max(255, 'Block should not exceed 255 characters')
    .required('Required'),
  finalize_copy_header: Yup.string()
    .min(2, 'Header should contain at least 2 characters')
    .max(50, 'Header should not exceed 50 characters')
    .required('Required'),
  finalize_copy_body: Yup.string()
    .min(10, 'Copy should contain at least 10 characters')
    .max(400, 'Copy should not exceed 400 characters')
    .required('Required'),
})
